module.exports = __webpack_public_path__ + "static/media/java-expert.eedf8870.png";